export default function LifePage() {
  return (
    <div className="pb-grid">
      <main>
        <p className="pb-lbl">Life</p>
        <h1 className="pb-h1">Coming soon.</h1>
        <p className="pb-dek">Photos, travel and the off-screen stuff will live here.</p>
        <p className="pb-more">
          <a href="#/">Ask me anything instead</a>
        </p>
      </main>
    </div>
  );
}
